/**
 * DPA 商品库相关
 */
import apis from 'src/const/apis';
import request from 'src/utils/request';
import * as types from 'src/store/types';
import { getCatalogAvailableLocation, getCatalogInfo, formatPath } from 'src/service/dpa';

const catalog = {
  namespaced: true,
  state: {
    collectionAdsCatalog: null,
    catalogAvailableLocation: [],
    loadingCatalogAvailableLocation: false,
  },
  getters: {
    collectionAdsCatalogCountry(state) {
      const list = state.collectionAdsCatalog?.refer_catalogs?.map(item => item.country) ?? [];
      return [...new Set(list)];
    },
    collectionAdsReferCatalogs(state) {
      return state.collectionAdsCatalog?.refer_catalogs ?? [];
    },
    collectionAdsIsCrossBorderCatalog(state) {
      return state.collectionAdsCatalog?.is_multi_country_lang;
    },
    getLanguageCorrespondingCountry: (state, getters) => language => [...new Set(
      getters.collectionAdsReferCatalogs
        .filter(item => item.language === language)
        .map(item => item.country),
    )],
  },
  mutations: {
    [types.SET_CATALOG_AVAILABLE_LOCATION](state, country = []) {
      state.catalogAvailableLocation = country;
    },
    [types.SET_LOADING_CATALOG_AVAILABLE_LOCATION](state, status) {
      state.loadingCatalogAvailableLocation = status;
    },
    [types.SET_COLLECTION_ADS_CATALOG](state, catalogData) {
      state.collectionAdsCatalog = catalogData;
    },
  },
  actions: {
    // 获取商品库信息
    async getCollectionAdsCatalogInfo({ commit }, ...args) {
      const data = await getCatalogInfo(...args);
      commit(types.SET_COLLECTION_ADS_CATALOG, data);
      return data;
    },
    // 获取商品库可投放国家
    async getCatalogAvailableLocation({ commit, state }) {
      const { catalogAvailableLocation } = state;
      if (catalogAvailableLocation.length) {
        return catalogAvailableLocation;
      }
      try {
        commit(types.SET_LOADING_CATALOG_AVAILABLE_LOCATION, true);
        const { countries = [] } = await getCatalogAvailableLocation({ transferToId: true });
        commit(types.SET_CATALOG_AVAILABLE_LOCATION, countries);
        commit(types.SET_LOADING_CATALOG_AVAILABLE_LOCATION, false);
        return countries;
      } catch (error) {
        commit(types.SET_LOADING_CATALOG_AVAILABLE_LOCATION, false);
        return Promise.reject(error);
      }
    },
    async checkCatalogAuthorized(context, catalogId) {
      const path = formatPath(apis.catalogue.checkAuthorized, { catalogId });
      return request.get(path)
        .then(res => res.data.authorized)
        .catch((res) => {
          switch (res.code) {
            // 这个code是商品库被删除了，所以认为也是没有权限的
            case 40003:
            case 40020:
              return false;
            default:
              return true;
          }
        });
    },
  },
};

export default catalog;
